import posthog from 'posthog-js'

interface UserIdentifier {
  email?: string
  name?: string
  phone?: string
}

export function sendEvent(
  eventName: string,
  eventData?: Record<string, string | boolean> | boolean,
): void {
  const properties =
    typeof eventData === 'boolean' ? { value: eventData } : eventData
  try {
    if (posthog && posthog.__loaded) {
      posthog.capture(eventName, properties)
    } else {
      console.warn('PostHog not initialized or not loaded yet')
    }
  } catch (error) {
    console.error('Failed to send PostHog event:', error)
  }
}

export function identifyUser(identifier: UserIdentifier): void {
  try {
    if (posthog && posthog.__loaded && identifier.email) {
      const doIdentify = () => {
        posthog.identify(identifier.email!, {
          email: identifier.email,
          name: identifier.name,
          phone: identifier.phone,
        })
      }

      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(doIdentify, { timeout: 100 })
      } else {
        setTimeout(doIdentify, 0)
      }
    }
  } catch (error) {
    console.error('Failed to identify user in PostHog:', error)
  }
}

export function trackPageView(pageTitle: string, pagePath?: string): void {
  const params: Record<string, string> = { page_title: pageTitle }
  if (pagePath) params.page_path = pagePath
  sendEvent('$pageview', params)
}
